import { HttpService } from '../../services/HttpService';
import { getSecureBaseUrl } from '../../services/UrlMapperService';
import { apiUrls } from '../../constants/apiUrl';
import * as Constants from './Constants';

export const callCradleApi = (data) => ({ type: Constants.CALL_CRADLE_API, data });

const formApiUrl = (urlKey = '') => `${getSecureBaseUrl()}${apiUrls()[urlKey]}`;

const genericPostCall = (apiUrl, postDataValue, sucessCallBack = () => {}, errorCallBack = () => {}) =>
  HttpService.post(apiUrl, postDataValue)
    .then((response) => sucessCallBack(response))
    .catch((error) => errorCallBack(error));

export const postCradleApi = (data) => {
  const apiURL = formApiUrl('cradleApi');

  const postData = {
    properties: [{ name: 'pageName', value: data?.name ? data?.name : '' }],
  };
  return new Promise((resolve) => genericPostCall(apiURL, postData, resolve));
};
